import {getMainParentRouteName} from "@/lib/lib";

export default {
    computed: {
        routeName() {
            return this.$route?.name || ''
        },
        routeFilter() {
            return this.$route?.params || {}
        },
        routeQueryFilter() {
            return this.$route?.query || {}
        },
        routeMeta() {
            return this.$route?.meta || {}
        },
        //ToDo fix call setRoute?.xxx()
        setRoute() {
            return this.routeMeta.setRoute || {}
        },
        parentRouteName() {
            return this.routeMeta.parentRouteName || ''
        },
        mainRouteName() {
            return this.routeMeta.mainRouteName || ''
        },
        mainParentRouteName() {
            return getMainParentRouteName(this.$route?.name)
        },

        routeTemplate() {
            //return this.$route?.params?.template || ''
            return this.routeFilter.template
        },
    },

}